module.exports = __webpack_public_path__ + "img/test2.06e759d7.png";